import { EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ITuple } from '@app/_models/tuple';
import { BaseDto } from '@app/_models/_DTOs/baseDto';
import { DataService } from '@app/_services/data.service';
import { NzTableComponent } from 'ng-zorro-antd';

export class EntitySelectorComponent<T extends BaseDto> implements OnInit {

    @Input() selectorHeight: number;
    @Output() selectionChanged = new EventEmitter<T[]>();

    @Input() sorts: string = "";
    @Input() filters: string = "";
    @Input() selectedIds: number[] = [];
    dataService: DataService<T>;

    pageIndex = 1;
    pageSize = 50;
    total = 1;
    dataList: T[] = [];
    loading = true;
    selectedItems: T[] = [];

    // User selection stuff
    allItemsSelected = false;
    isIndeterminate = false;
    mapOfCheckedIds: { [key: string]: boolean } = {};
    numberOfCheckedItems = 0;

    constructor(dataService: DataService<T>) {
        this.dataService = dataService;
    }

    ngOnInit() {
        this.search(true);
    }

    getHeight() {
        if (this.selectorHeight != undefined) {
            return { y: this.selectorHeight + 'px' }
        }
        return { y: '250px' }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["sorts"] || changes["filters"]) {
            this.search();
        }
        if (changes["selectedIds"]) {
            if(this.dataList && this.dataList.length > 0){
                this.initSelection();
            }
        }
    }

    search(reset: boolean = false): void {
        if (reset) {
            this.pageIndex = 1;
        }
        this.loading = true;
        this.dataService
            .getPage(this.pageIndex, this.pageSize, this.sorts, this.filters)
            .subscribe((data: ITuple<T>) => {
                this.loading = false;
                this.total = data.item2;
                this.dataList = data.item1;
                this.initSelection();
            });
    }

    initSelection() {
        if(this.selectedIds && this.selectedIds.length > 0){
            for (let selectedId of this.selectedIds) {
                this.mapOfCheckedIds = {};
                this.mapOfCheckedIds[selectedId] = true;
    
                var clickedItem = this.dataList.find(item => item.id == selectedId);
                this.addItemToSelection(clickedItem);
            }
    
            this.refreshStatus();
        }
    }

    refreshStatus(clickedId?: number): void {
        this.numberOfCheckedItems = Object.keys(this.mapOfCheckedIds).filter(x => this.mapOfCheckedIds[x] == true).length;
        this.allItemsSelected = this.numberOfCheckedItems == this.total;
        this.isIndeterminate = this.numberOfCheckedItems > 0 && !this.allItemsSelected;

        if (clickedId != null) {
            var clickedItem = this.dataList.find(item => item.id == clickedId);
            if (this.mapOfCheckedIds[clickedId]) {
                this.addItemToSelection(clickedItem);
            }
            else {
                this.removeItemFromSelection(clickedItem);
            }
        }
        this.selectionChanged.emit(this.selectedItems);
    }

    checkAll(value: boolean): void {
        this.dataList.forEach(item => (this.mapOfCheckedIds[item.id] = value));

        if (value == true) {
            let selectedUsers = this.dataList.filter(item => this.mapOfCheckedIds[item.id] == true);
            this.addManyToSelection(selectedUsers);
        }
        else {
            let deselectedUsers = this.dataList.filter(item => this.mapOfCheckedIds[item.id] == false);
            this.removeManyFromSelection(deselectedUsers);
        }
        this.refreshStatus();
    }

    public addItemToSelection(item: T) {
        if (!this.selectedItems.some(x => x.id == item.id)) {
            this.selectedItems.push(item);
            // onSelectionChange()
        }
    }

    public addManyToSelection(items: T[]) {
        for (let item of items) {
            this.addItemToSelection(item);
        }
        // onSelectionChange()
    }

    public removeItemFromSelection(item: T) {
        let userInSelectedUsers = this.selectedItems.find(x => x.id == item.id);
        const index = this.selectedItems.indexOf(userInSelectedUsers);
        if (index > -1) {
            this.selectedItems.splice(index, 1);
            if (this.mapOfCheckedIds[item.id]) {
                this.mapOfCheckedIds[item.id] = false;
            }
        }
    }

    public removeManyFromSelection(items: T[]) {
        for (let item of items) {
            this.removeItemFromSelection(item);
        }
        // onSelectionChange()
    }

    public deselectItem(item: T) {
        let userInSelectedUsers = this.selectedItems.find(x => x.id == item.id);
        const index = this.selectedItems.indexOf(userInSelectedUsers);
        if (index > -1) {
            this.selectedItems.splice(index, 1);
            if (this.mapOfCheckedIds[item.id]) {
                this.mapOfCheckedIds[item.id] = false;
            }
            this.refreshStatus();
            // onSelectionChange()
        }
    }
}